<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<el-button @click="dialogFormVisible = true" type="primary">添加类目</el-button>
			</div>
			<el-table ref="multipleTable" :data="topicClassList" tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="cate_id" label="ID" width="50">
				</el-table-column>
				<el-table-column prop="cate_name" label="类目名称">
				</el-table-column>
				<el-table-column align="center" label="封面" prop="cover_image">
					<el-image slot-scope="scope" style="width: 80px; height: 80px" :src="scope.row.cover_image"></el-image>
				</el-table-column>
				<el-table-column align="center" label="管理" width="200">
					<template slot-scope="scope">
						<el-button @click="classEdit(scope.row)">编辑</el-button>
						<el-popconfirm style="margin-left: 5px;" confirmButtonText='确定' cancelButtonText='取消' @onConfirm="classDel(scope.row.cate_id,scope.$index)"
						 icon="el-icon-info" iconColor="red" title="确定删除？">
							<el-button slot="reference" type="danger">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		<!-- 添加圈子类目弹窗 -->
		<el-dialog title="创建类目" :visible.sync="dialogFormVisible" @close="closeDialog">
			<el-form :model="form" ref="form">
				<el-form-item label="类目名称">
					<el-input v-model="form.cate_name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="封面">
					<el-upload ref="uUpload" class="avatar-uploader" name="Image" :headers="headers" :action="action" :on-success="uploadSuccess1"
					 :show-file-list="false">
						<img v-if="form.cover_image" :src="form.cover_image" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="classAdd">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				btnLoading: false,
				btnDisabled: false,
				action: this.$c.domain + "common/upload",
				headers: {
					token: this.$store.state.userInfo.token
				},
				topicClassList: [],
				dialogFormVisible: false,
				form: {
					cate_name: "",
					cover_image: ""
				},
			}
		},
		created() {
			this.getTopicClass();
		},
		methods: {
			getTopicClass() {
				this.$H.get("topic/classList").then((res) => {
					this.topicClassList = res.result;
				})
			},
			classDel(id, index) {
				this.$H.post("topic/cateDel", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.topicClassList.splice(index, 1);
						this.$message.success('删除成功');
						this.getTopicClass();
					}
				})
			},
			uploadSuccess1(e) {
				if (e.code == 200) {
					this.form.cover_image = e.result.url;
				}
			},
			classAdd() {
				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("topic/cateAddEdit", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.$refs.uUpload.clearFiles();
						this.$message.success(res.msg)
						this.dialogFormVisible = false;
						this.getTopicClass();
					}
					if (this.form.hasOwnProperty("cate_id")) {
						delete this.form.cate_id;
					}
					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			classEdit(data) {
				this.dialogFormVisible = true;
				this.form.cate_id = data.cate_id;
				this.form.cate_name = data.cate_name;
				this.form.cover_image = data.cover_image;
			},
			closeDialog() {
				if (this.form.hasOwnProperty("cate_id")) {
					delete this.form.cate_id;
				}
				this.form.cate_name = '';
				this.form.cover_image = '';
			}

		}
	}
</script>

<style>
	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}
</style>
